import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
	IBrand,
	IJoinedInviteBrand,
	IJoinedInviteOffer,
	IJoinedOffer,
	IOpenedOffer,
	TOpenedModal,
} from 'entities/Brand';

interface ISourceSlice {
	joinedBrand: IBrand | null;
	joinedInviteBrand: IJoinedInviteBrand | null;
	joinedOffer: IJoinedOffer | null;
	joinedInviteOffer: IJoinedInviteOffer | null;
	openedOffer: IOpenedOffer | null;
	openedModal: TOpenedModal;
	joinedSources: string[] | null;
}

const initialState: ISourceSlice = {
	joinedBrand: null,
	joinedInviteBrand: null,
	joinedOffer: null,
	joinedInviteOffer: null,
	openedOffer: null,
	openedModal: null,
	joinedSources: null,
};

export const brandsSlice = createSlice({
	name: 'brands',
	initialState,
	reducers: {
		setJoinedBrand: (state, action: PayloadAction<IBrand | null>) => {
			state.joinedBrand = action.payload;
			state.openedOffer = null;
		},
		setJoinedInviteBrand: (state, action: PayloadAction<IJoinedInviteBrand | null>) => {
			state.joinedInviteBrand = action.payload;
		},
		setJoinedOffer: (state, action: PayloadAction<IJoinedOffer | null>) => {
			state.joinedOffer = action.payload;
		},
		setJoinedInviteOffer: (state, action: PayloadAction<IJoinedInviteOffer | null>) => {
			state.joinedInviteOffer = action.payload;
		},
		setOpenedOffer: (state, action: PayloadAction<IOpenedOffer | null>) => {
			state.openedOffer = action.payload;
			state.joinedBrand = null;
		},
		setOpenedModal: (state, action: PayloadAction<TOpenedModal>) => {
			state.openedModal = action.payload;
		},
		setJoinedSources: (state, action: PayloadAction<string[] | null>) => {
			state.joinedSources = action.payload;
		},
	},
});

export default brandsSlice.reducer;
export const {
	setJoinedBrand,
	setJoinedInviteBrand,
	setJoinedOffer,
	setJoinedInviteOffer,
	setOpenedOffer,
	setOpenedModal,
	setJoinedSources,
} = brandsSlice.actions;
